/*
 * File: partner.slice.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:50 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: April 1, 2025 at 1:29 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import { createSlice } from '@reduxjs/toolkit';


/**
 * Constants
 */

export const initialState = {
	status: 'idle',
	error: null,
	value: {},
};


/**
 * Slices
 */

export const partnerSlice = createSlice({
	name: 'partner',
	initialState,
	reducers: {
		updatePartner: (state, action) => {

			// Set state
			state.value = { ...action.payload };
		},
		clearPartner: (state) => {

			// Clear state
			state.value = { ...initialState.value };
		},
	},
	extraReducers: {},
});


/**
 * Exports
 */

export const { updatePartner, clearPartner } = partnerSlice.actions;

export default partnerSlice.reducer;
